module.exports = __webpack_public_path__ + "static/media/Punkl.85502773.jpeg";